module.exports = __webpack_public_path__ + "img/background19.0beb3e81.jpg";